import { ITemplatesStore } from '../index'
import { IRejectTemplates } from '../../../actions/templates/loadTemplates'

export default function(
  store: ITemplatesStore,
  action: IRejectTemplates,
): ITemplatesStore {
  return {
    ...store,
    request: {
      ...store.request,
      errMessage: action.errMessage,
      isLoading: false,
    },
  }
}
